import React from 'react';
import { AdminPageShell } from '../_components/AdminPageShell';
import { JurisdictionsPanel } from '@/components/admin/JurisdictionsPanel';

export const AdminJurisdictionsPage: React.FC = () => (
  <AdminPageShell title="Jurisdictions">
    <JurisdictionsPanel />
  </AdminPageShell>
);
